var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { generateReducer, } from "../generators/generator.reducer";
import { getQueryHash } from "../utils/hash.utils";
import { getCountStepsFailed, getCountStepsStart, getCountStepsSucceeded, updateApplicationStepSucceeded, remindCandidateTenantStart, remindCandidateTenantSucceeded, remindCandidateTenantFailed, applicationGroupActionsStart, applicationGroupActionsSucceeded, applicationGroupActionsFailed, setApplicationFlagSucceeded, setApplicationNoShowSucceeded, setApplicationRatingSucceeded, archiveSucceeded, unarchiveSucceeded, } from "./application.actions";
import { GENERATOR_PARAMS } from "./application.constants";
var getExtraDefaultState = function () { return ({
    countSteps: {},
    remindCandidateTenant: {},
    groupActions: {},
}); };
var _reducer = generateReducer(GENERATOR_PARAMS, getExtraDefaultState);
var reducer = _reducer;
reducer.on(applicationGroupActionsStart.type, function (state, payload) {
    var _a;
    var propertyId = payload.data.propertyIds[0];
    return __assign(__assign({}, state), { groupActions: __assign(__assign({}, state.groupActions), (_a = {}, _a[propertyId] = __assign(__assign({}, state.groupActions[propertyId]), { pending: true, error: undefined }), _a)) });
});
reducer.on(applicationGroupActionsSucceeded.type, function (state, payload) {
    var _a;
    var propertyId = payload.propertyId;
    return __assign(__assign({}, state), { groupActions: __assign(__assign({}, state.groupActions), (_a = {}, _a[propertyId] = __assign(__assign({}, state.groupActions[propertyId]), { pending: false, result: payload.result, error: undefined }), _a)) });
});
reducer.on(applicationGroupActionsFailed.type, function (state, payload) {
    var _a;
    var propertyId = payload.propertyId;
    return __assign(__assign({}, state), { groupActions: __assign(__assign({}, state.groupActions), (_a = {}, _a[propertyId] = __assign(__assign({}, state.groupActions[propertyId]), { pending: false, error: payload.error }), _a)) });
});
reducer.on(updateApplicationStepSucceeded.type, function (state, payload) {
    var _a;
    var _b, _c, _d, _e, _f, _g, _h;
    return (__assign(__assign({}, state), { detail: __assign(__assign({}, state.detail), (_a = {}, _a["".concat(payload.id)] = {
            pending: false,
            entity: __assign(__assign(__assign({}, (_b = state.detail["".concat(payload.id)]) === null || _b === void 0 ? void 0 : _b.entity), payload.result), { otherApplicationsMeta: (_c = payload.result.otherApplicationsMeta) !== null && _c !== void 0 ? _c : (_e = (_d = state.detail["".concat(payload.id)]) === null || _d === void 0 ? void 0 : _d.entity) === null || _e === void 0 ? void 0 : _e.otherApplicationsMeta, otherApplicationsTotalCount: (_f = payload.result.otherApplicationsTotalCount) !== null && _f !== void 0 ? _f : (_h = (_g = state.detail["".concat(payload.id)]) === null || _g === void 0 ? void 0 : _g.entity) === null || _h === void 0 ? void 0 : _h.otherApplicationsTotalCount }),
        }, _a)) }));
});
// The mark belongs to the candidate, not to this candidacy, so every candidacy
// of the same candidate already in the store takes it over, wherever it was
// loaded from (the office's other properties, the other-applications modal).
reducer.on(setApplicationFlagSucceeded.type, function (state, payload) {
    var _a, _b, _c, _d;
    var flag = (_a = payload.result.flag) !== null && _a !== void 0 ? _a : null;
    var userId = payload.result.userId;
    var detail = __assign({}, state.detail);
    Object.keys(detail).forEach(function (key) {
        var entry = detail[key];
        if (!(entry === null || entry === void 0 ? void 0 : entry.entity) || key === "".concat(payload.id))
            return;
        if (!userId || entry.entity.userId !== userId)
            return;
        detail[key] = __assign(__assign({}, entry), { entity: __assign(__assign({}, entry.entity), { flag: flag }) });
    });
    var previous = (_b = state.detail["".concat(payload.id)]) === null || _b === void 0 ? void 0 : _b.entity;
    detail["".concat(payload.id)] = {
        pending: false,
        entity: __assign(__assign(__assign({}, previous), payload.result), { flag: flag, otherApplicationsMeta: (_c = payload.result.otherApplicationsMeta) !== null && _c !== void 0 ? _c : previous === null || previous === void 0 ? void 0 : previous.otherApplicationsMeta, otherApplicationsTotalCount: (_d = payload.result.otherApplicationsTotalCount) !== null && _d !== void 0 ? _d : previous === null || previous === void 0 ? void 0 : previous.otherApplicationsTotalCount }),
    };
    return __assign(__assign({}, state), { detail: detail });
});
reducer.on(setApplicationNoShowSucceeded.type, function (state, payload) {
    var _a;
    var _b, _c, _d, _e, _f, _g, _h;
    return (__assign(__assign({}, state), { detail: __assign(__assign({}, state.detail), (_a = {}, _a["".concat(payload.id)] = {
            pending: false,
            entity: __assign(__assign(__assign({}, (_b = state.detail["".concat(payload.id)]) === null || _b === void 0 ? void 0 : _b.entity), payload.result), { otherApplicationsMeta: (_c = payload.result.otherApplicationsMeta) !== null && _c !== void 0 ? _c : (_e = (_d = state.detail["".concat(payload.id)]) === null || _d === void 0 ? void 0 : _d.entity) === null || _e === void 0 ? void 0 : _e.otherApplicationsMeta, otherApplicationsTotalCount: (_f = payload.result.otherApplicationsTotalCount) !== null && _f !== void 0 ? _f : (_h = (_g = state.detail["".concat(payload.id)]) === null || _g === void 0 ? void 0 : _g.entity) === null || _h === void 0 ? void 0 : _h.otherApplicationsTotalCount }),
        }, _a)) }));
});
reducer.on(setApplicationRatingSucceeded.type, function (state, payload) {
    var _a;
    var _b, _c, _d, _e, _f, _g, _h;
    return (__assign(__assign({}, state), { detail: __assign(__assign({}, state.detail), (_a = {}, _a["".concat(payload.id)] = {
            pending: false,
            entity: __assign(__assign(__assign({}, (_b = state.detail["".concat(payload.id)]) === null || _b === void 0 ? void 0 : _b.entity), payload.result), { otherApplicationsMeta: (_c = payload.result.otherApplicationsMeta) !== null && _c !== void 0 ? _c : (_e = (_d = state.detail["".concat(payload.id)]) === null || _d === void 0 ? void 0 : _d.entity) === null || _e === void 0 ? void 0 : _e.otherApplicationsMeta, otherApplicationsTotalCount: (_f = payload.result.otherApplicationsTotalCount) !== null && _f !== void 0 ? _f : (_h = (_g = state.detail["".concat(payload.id)]) === null || _g === void 0 ? void 0 : _g.entity) === null || _h === void 0 ? void 0 : _h.otherApplicationsTotalCount }),
        }, _a)) }));
});
reducer.on(getCountStepsStart.type, function (state, payload) {
    var _a;
    var countStepsKey = getQueryHash(payload.query);
    return __assign(__assign({}, state), { countSteps: __assign(__assign({}, state.countSteps), (_a = {}, _a[countStepsKey] = __assign(__assign({}, state.countSteps[countStepsKey]), { pending: true, error: undefined }), _a)) });
});
reducer.on(getCountStepsSucceeded.type, function (state, payload) {
    var _a;
    var countStepsKey = getQueryHash(payload.query);
    return __assign(__assign({}, state), { countSteps: __assign(__assign({}, state.countSteps), (_a = {}, _a[countStepsKey] = __assign(__assign({}, state.countSteps[countStepsKey]), { pending: false, result: payload.result, error: undefined }), _a)) });
});
reducer.on(getCountStepsFailed.type, function (state, payload) {
    var _a;
    var countStepsKey = getQueryHash(payload.query);
    return __assign(__assign({}, state), { countSteps: __assign(__assign({}, state.countSteps), (_a = {}, _a[countStepsKey] = __assign(__assign({}, state.countSteps[countStepsKey]), { pending: false, error: payload.error }), _a)) });
});
reducer.on(remindCandidateTenantStart.type, function (state, payload) {
    var _a;
    return __assign(__assign({}, state), { remindCandidateTenant: __assign(__assign({}, state.remindCandidateTenant), (_a = {}, _a[payload.applicationId] = __assign(__assign({}, state.remindCandidateTenant[payload.applicationId]), { pending: true, error: undefined }), _a)) });
});
reducer.on(remindCandidateTenantSucceeded.type, function (state, payload) {
    var _a;
    return __assign(__assign({}, state), { remindCandidateTenant: __assign(__assign({}, state.remindCandidateTenant), (_a = {}, _a[payload.applicationId] = __assign(__assign({}, state.remindCandidateTenant[payload.applicationId]), { pending: false, result: payload.result, error: undefined }), _a)) });
});
reducer.on(remindCandidateTenantFailed.type, function (state, payload) {
    var _a;
    return __assign(__assign({}, state), { remindCandidateTenant: __assign(__assign({}, state.remindCandidateTenant), (_a = {}, _a[payload.applicationId] = __assign(__assign({}, state.remindCandidateTenant[payload.applicationId]), { pending: false, error: payload.error }), _a)) });
});
/**
 * Archiving a candidate dropped the cross-property information from the store,
 * so the "candidate for N properties" line vanished until a reload (DEV-3152).
 *
 * The generic reducer replaces the whole entity with the archive response, and
 * that response does not carry otherApplicationsMeta or the count: those are
 * assembled by a separate query on the list endpoint. So the fields were not
 * changed, they were dropped.
 *
 * This merges instead of replacing, the same way the step, no-show and rating
 * handlers above already do.
 *
 * Note that this REPLACES the generic handler rather than running beside it:
 * redux-act keeps one handler per action type and a later `on` overwrites the
 * earlier one. That is why the archive bookkeeping is repeated here. It is not
 * duplication for its own sake; leaving it out would leave the pending flag
 * stuck after every archive.
 */
var mergeArchiveResponse = function (state, payload) {
    var _a, _b;
    var _c, _d, _e;
    var existing = (_c = state.detail["".concat(payload.id)]) === null || _c === void 0 ? void 0 : _c.entity;
    var result = payload.result.data;
    return __assign(__assign({}, state), { detail: __assign(__assign({}, state.detail), (_a = {}, _a["".concat(payload.id)] = __assign(__assign({}, state.detail["".concat(payload.id)]), { entity: __assign(__assign(__assign({}, existing), result), { otherApplicationsMeta: (_d = result === null || result === void 0 ? void 0 : result.otherApplicationsMeta) !== null && _d !== void 0 ? _d : existing === null || existing === void 0 ? void 0 : existing.otherApplicationsMeta, otherApplicationsTotalCount: (_e = result === null || result === void 0 ? void 0 : result.otherApplicationsTotalCount) !== null && _e !== void 0 ? _e : existing === null || existing === void 0 ? void 0 : existing.otherApplicationsTotalCount }) }), _a)), archive: __assign(__assign({}, state.archive), (_b = {}, _b["".concat(payload.id)] = {
            pending: false,
            error: undefined,
        }, _b)) });
};
reducer.on(archiveSucceeded.type, mergeArchiveResponse);
reducer.on(unarchiveSucceeded.type, mergeArchiveResponse);
// eslint-disable-next-line import/no-default-export
export default reducer;
